import { useEffect, useState } from 'react';
import { Menu, MenuItem, Button } from '@mui/material';
import { supportedLanguages } from '../utils/languageHelper';
import { useAppDispatch, useAppSelector } from '../store/configureStore';
import { selectLanguage, setDefaultLanguage } from './languageSlice';

const LanguageSelector = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useAppDispatch();
  const { selectedLanguage } = useAppSelector((state) => state.language);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleMenuOpen = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  useEffect(() => {
    dispatch(setDefaultLanguage());
  }, []);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleMenuClose = (event: any) => {
    setAnchorEl(null);
    dispatch(selectLanguage(supportedLanguages.get(event.target.value)!));
  };

  return (
    <>
      <Button
        onClick={handleMenuOpen}
        sx={{
          width: '48px',
          height: '48px',
          borderRadius: '50%',
          fontSize: '1.5rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minWidth: '48px',
          padding: 0,
          '&:hover': {
            backgroundColor: 'rgba(245, 31, 85, 0.04)',
          },
        }}
      >
        {`${selectedLanguage.flag}`}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        {Array.from(supportedLanguages.entries()).map(([key, value]) => (
          <MenuItem key={key} value={key} onClick={handleMenuClose}>
            {`${value.flag} ${value.language}`}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSelector;
